import { z } from "zod";

export const SupportTicketSchema = z.object({
  tenantId: z.string(),
  createdByUid: z.string(),
  subject: z.string().min(1),
  category: z.enum(["question", "billing", "integrations", "bug", "feature", "other"]),
  priority: z.enum(["low", "normal", "high", "urgent"]).default("normal"),
  status: z.enum(["open", "waiting_on_customer", "waiting_on_support", "closed"]).default("open"),
  lastMessageAt: z.number(),
  unreadForCustomer: z.boolean().default(false),
  unreadForSupport: z.boolean().default(true),
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type SupportTicket = z.infer<typeof SupportTicketSchema>;

export const TicketMessageSchema = z.object({
  authorUid: z.string(),
  voice: z.enum(["customer", "support"]),
  body: z.string().min(1),
  attachmentPaths: z.array(z.string()).max(10).default([]),
  createdAt: z.number(),
});
export type TicketMessage = z.infer<typeof TicketMessageSchema>;

export const RemoteSupportSessionSchema = z.object({
  tenantId: z.string(),
  tenantName: z.string().nullable().default(null),
  code: z.string().length(6),
  status: z.enum(["pending", "connected", "ended", "expired"]).default("pending"),
  createdByUid: z.string(),
  createdByEmail: z.string().nullable().default(null),
  adminUid: z.string().nullable().default(null),
  adminEmail: z.string().nullable().default(null),
  endedBy: z.enum(["customer", "admin", "expiry"]).nullable().default(null),
  createdAt: z.number(),
  expiresAt: z.number(),
  connectedAt: z.number().nullable().default(null),
  endedAt: z.number().nullable().default(null),
  updatedAt: z.number(),
});
export type RemoteSupportSession = z.infer<typeof RemoteSupportSessionSchema>;
